import firstImage from "../assets/Servizi/1.jpg";
import secondImage from "../assets/Servizi/2.png";
import thirdImage from "../assets/Servizi/3.png";
import fourthImage from "../assets/Servizi/4.png";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


export default function GridBox( { handleClickForm } ) {

    const boxes = [
        {
            title: "Infortunato? Torna in campo",
            description: "Percorso Rimessa in Campo per il recupero funzionale sport-specifico.",
            image: firstImage,
            alt: "infortunio durante l'attività sportiva",
            button: "Voglio ripartire"
        },
        {
            title: "Recupero post-chirurgico",
            description: "Processo post-chirurgico avanzato per il ritorno alla performance.",
            image: secondImage,
            alt:"recupero atletico post intervento chirurgico",
            button: "Inizia il post-op"
        },
        {
            title: "Il dolore ti ferma?",
            description: "Diagnosi funzionale e piano di recupero entro 48h.",
            image: thirdImage,
            alt: "dolore localizzato su un punto del corpo che non permette di vivere in serenità le proprie giornate",
            button: "Riparti ora"
        },
        {
            title: "Previeni infortuni e migliora te stesso",
            description: "Screening atletico stagionale per massimizzare il tuo potenziale.",
            image: fourthImage,
            alt: "attività fisica per la prevenzione di infortuni muscolari con screening atletico",
            button: "Migliora le tue performance"
        }
    ];

    

    return (
        <>
        <div className="md:grid grid-cols-2 grid-rows-2 hidden h-screen">
            {boxes.map((box, index) => (
                <div key={index} className="relative text-white group">
                    <img src={box.image} alt={box.alt} className={`w-full h-full object-cover object-[50%_15%]`} />
                    <div className="absolute inset-0 bg-black/70"/>
                    
                    <div className={`absolute top-1/2 -translate-y-1/2 left-0 w-full h-full flex items-center opacity-0 transition-opacity duration-300 group-hover:opacity-100`}>
                        <div className="flex flex-col items-start text-start gap-2 p-10 xl:w-2/3">
                            <h3 className="font-semibold text-xl panoragraf-light uppercase italic">{box.title}</h3>
                            <p className="text-lg text-balance">{box.description}</p>
                            <button
                                onClick={handleClickForm}
                                className="mt-4 progress-button-mcare px-8 py-4 text-center w-full lg:w-2/3">
                                {box.button}
                            </button>
                        </div>
                    </div>
                </div>
            ))} 
        </div>

        {/* Mobile version */}
        <div className="block md:hidden">
            <Swiper
                slidesPerView={1}
                spaceBetween={20}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                pagination={{
                    dynamicBullets: true,
                    clickable: true,
                }}
                modules={[Autoplay, Pagination]}
                className="w-full"
            >
            {boxes.map((box, index) => (
                <SwiperSlide key={index}>
                    <div className="relative text-white h-[500px] overflow-hidden">
                        <img
                            src={box.image}
                            alt={box.alt}
                            className={`w-full h-full object-cover ${index === 1 ? 'object-right scale-150' : 'object-[50%_15%]'}`}
                        />

                        <div className="absolute inset-0 bg-black/70"></div>

                        <div className="absolute inset-0 flex items-center">
                            <div className="flex flex-col items-start text-start gap-2 p-10">
                                <h3 className="font-semibold text-lg panoragraf-light uppercase italic">
                                    {box.title}
                                </h3>

                                <p className="text-base text-balance">
                                    {box.description}
                                </p>

                                <button
                                    onClick={handleClickForm}
                                    className="mt-4 progress-button-mcare px-8 py-4 text-center w-full lg:w-2/3">
                                    {box.button}
                                </button>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
            </Swiper>
        </div>

        </>
    )
}
